export default __webpack_public_path__ + "db07c47172e03f5dda44c85d1910d70c.png";